import TagManager from 'react-gtm-module';
import { isTrackingAllowed } from './consent';

/** Nome do evento personalizado no GTM (gatilho Google Ads — conversão). */
export const GTM_CONVERSION_EVENT = 'cadastro_concluido';

const GTM_ID = import.meta.env.VITE_GTM_ID?.trim() ?? '';

let gtmInitialized = false;

export function isGtmConfigured(): boolean {
  return GTM_ID.length > 0;
}

export function initGtm(): void {
  if (gtmInitialized || !isGtmConfigured()) {
    return;
  }
  if (!isTrackingAllowed()) {
    return;
  }

  try {
    TagManager.initialize({ gtmId: GTM_ID });
    gtmInitialized = true;
  } catch (error) {
    if (import.meta.env.VITE_APP_ENV !== 'PROD') {
      console.warn('[analytics][gtm] init failed', error);
    }
  }
}

export function pushGtmEvent(
  event: string,
  payload?: Record<string, unknown>,
): void {
  if (!isTrackingAllowed() || !isGtmConfigured()) {
    return;
  }

  initGtm();
  if (!gtmInitialized) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...payload });
}

export function trackGtmSignupConversion(extra?: Record<string, unknown>): void {
  pushGtmEvent(GTM_CONVERSION_EVENT, {
    app_env: import.meta.env.VITE_APP_ENV ?? 'DEV',
    ...extra,
  });
}
